import React, { useMemo, useState } from "react";

import ReviewPanel from "./ReviewPanel";
import type {
  CourseEvaluatorReviewDecision,
  CourseEvaluatorReviewMockData,
  CourseEvaluatorReviewSidebarItemMock,
} from "./mockData/courseEvaluatorReview.mockData";

interface CourseEvaluatorReviewContainerProps {
  review: CourseEvaluatorReviewMockData;
  onExitReview: () => void;
}

function CourseEvaluatorReviewContainer({ review, onExitReview }: CourseEvaluatorReviewContainerProps) {
  const [selectedItemId, setSelectedItemId] = useState<string | null>(null);
  const [filterMode, setFilterMode] = useState<"all" | "undecided">("all");
  const [collapsedSectionIds, setCollapsedSectionIds] = useState<Set<string>>(
    () => new Set(review.sidebarGroups.filter((group) => !group.defaultExpanded).map((group) => group.id))
  );

  const selectedSidebarItem = useMemo<CourseEvaluatorReviewSidebarItemMock | null>(() => {
    if (!selectedItemId) {
      return null;
    }

    return review.sidebarGroups.flatMap((group) => group.items).find((item) => item.id === selectedItemId) || null;
  }, [review.sidebarGroups, selectedItemId]);
  const selectedDecision: CourseEvaluatorReviewDecision = null;

  const reviewedProgress = review.totalCount > 0 ? (review.reviewedCount / review.totalCount) * 100 : 0;

  const toggleSection = (sectionId: string) => {
    setCollapsedSectionIds((previous) => {
      const next = new Set(previous);

      if (next.has(sectionId)) {
        next.delete(sectionId);
      } else {
        next.add(sectionId);
      }

      return next;
    });
  };

  return (
    <ReviewPanel
      review={review}
      selectedItemId={selectedItemId}
      selectedReviewItem={selectedSidebarItem}
      selectedDecision={selectedDecision}
      filterMode={filterMode}
      collapsedSectionIds={collapsedSectionIds}
      reviewedProgress={reviewedProgress}
      onExitReview={onExitReview}
      onSelectItem={setSelectedItemId}
      onToggleSection={toggleSection}
      onFilterModeChange={setFilterMode}
      onStartReviewing={() => undefined}
    />
  );
}

export default CourseEvaluatorReviewContainer;
